import { AfterViewInit, Component, OnInit } from '@angular/core';
import { Webflow } from 'src/app/utils/webflow';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-payment-cancel',
  templateUrl: './payment-cancel.component.html',
  styleUrls: ['./payment-cancel.component.scss']
})
export class PaymentCancelComponent implements OnInit, AfterViewInit {

  constructor() { }

  ngOnInit(): void {
  }

  ngAfterViewInit(): void {
    Webflow.setIFrameHeight();
  }

  redirectToWebflow(slug: string) {
    const baseUrl = environment.webflow_url;
    return `${baseUrl}${slug}`;
  }

}
